import { render, staticRenderFns } from "./Hit.vue?vue&type=template&id=c8fa522e"
import script from "./Hit.vue?vue&type=script&lang=ts"
export * from "./Hit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports